import api from './api';

// The one global platform cut (basis points, taken out of the manufacturer's
// price). Readable by every dashboard user, editable by super admins.
export interface MarketplaceSettings {
  platform_fee_bps: number;
  updated_at: string | null;
}

export async function getMarketplaceSettings(): Promise<MarketplaceSettings> {
  const response = await api.get<MarketplaceSettings>('/platform-settings/marketplace');
  return response.data;
}

export async function updateMarketplaceSettings(data: { platform_fee_bps: number }): Promise<MarketplaceSettings> {
  const response = await api.put<MarketplaceSettings>('/platform-settings/marketplace', data);
  return response.data;
}

/** 1500 → "15%", 1250 → "12.5%" */
export function formatBps(bps: number): string {
  return `${(bps / 100).toLocaleString('en-US', { maximumFractionDigits: 2 })}%`;
}
